


const getUrlKey = function (name) {
    return (
        decodeURIComponent(
            (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
                decodeURIComponent(location.href)
                // eslint-disable-next-line no-sparse-arrays
            ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
    );
}
export { getUrlKey }